// "use server"

// import { stripe } from "../../lib/stripe"
// import { PRODUCTS } from "../../lib/products"

// export async function startCheckoutSession(productId: string) {
//   const product = PRODUCTS.find((p) => p.id === productId)
//   if (!product) {
//     throw new Error(`Product with id "${productId}" not found`)
//   }

//   const session = await stripe.checkout.sessions.create({
//     ui_mode: "embedded",
//     redirect_on_completion: "never",
//     line_items: [
//       {
//         price_data: {
//           currency: "usd",
//           product_data: {
//             name: product.name,
//             description: product.description,
//           },
//           unit_amount: product.priceInCents,
//         },
//         quantity: 1,
//       },
//     ],
//     mode: "payment",
//   })

//   return session.client_secret
// }



export async function startCheckoutSession(productId: string): Promise<string> {
  const res = await fetch("https://latangelarogers.com/wp-json/latangela/v1/create-checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productId }),
  });

  const data = await res.json();
  if (!data.client_secret) throw new Error("Failed to fetch client secret");
  return data.client_secret;
}